import { render, staticRenderFns } from "./Transcript.vue?vue&type=template&id=21c20f7e&lang=pug&"
import script from "./Transcript.vue?vue&type=script&lang=js&"
export * from "./Transcript.vue?vue&type=script&lang=js&"
import style0 from "./Transcript.vue?vue&type=style&index=0&id=21c20f7e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports